<template>
  <div class="content">
    <div class="cp-bg">
      <div class="d-flex-s" style="padding: 16px">
        <van-icon
          name="arrow-left"
          @click="goToBack"
          size="20"
          color="#1F2A47"
        />
        <p class="f-w" style="font-size: var(--vk-fs-md)">{{ $lang.common_txt31 }}</p>
        <p></p>
      </div>
      <div v-if="readError" class="cp-read-error">
        {{ readError }}
      </div>
      <div class="dp-bg">
        <p>{{ creditPoints }}</p>
        <p style="font-size: var(--vk-fs-15) !important; color: #23baae">
          {{ $lang.common_txt66 }}
        </p>
      </div>
    </div>
    <div class="cp-bootom--b">
      <div class="cp-bootom">
        <p class="f-t-18 f-w t-c m-b-10">
          {{ $lang.common_txt32 }}
        </p>
        <p class="font-color" style="line-height: 20px">
          {{ $lang.common_txt33 }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { Init } from '@/api/common'
import { contentOf, failMessage, handleNeedLogin, isOk, toNumber } from './safeFlow'

function safeToast(vm, payload) {
  if (vm && typeof vm.$toast === 'function') vm.$toast(payload)
}

function cpFailureMessage(error, fallback) {
  const message = failMessage(error, fallback)
  return /^network error$/i.test(String(message || '').trim()) ? fallback : message
}

function fallbackToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function isReadUnavailableToken(value) {
  const token = fallbackToken(value)
  if (!token || token.includes('unblocked') || token.includes('not blocked')) return false
  return token.includes('mock') ||
    token.includes('fallback') ||
    token.includes('read_only') ||
    token.includes('readonly') ||
    token.includes('read only') ||
    token.includes('read-only') ||
    token.includes('read_only_reward') ||
    token.includes('readonlyreward') ||
    token.includes('read only reward') ||
    token.includes('read-only-reward') ||
    token.includes('read_only_query') ||
    token.includes('readonlyquery') ||
    token.includes('read only query') ||
    token.includes('read-only-query') ||
    token.includes('unimplemented') ||
    token.includes('not_implemented') ||
    token.includes('not implemented') ||
    token.includes('not_supported') ||
    token.includes('not-supported') ||
    token.includes('not supported') ||
    token.includes('not_connected') ||
    token.includes('not-connected') ||
    token.includes('not connected') ||
    token.includes('unsupported') ||
    token.includes('data_unavailable') ||
    token.includes('dataunavailable') ||
    token.includes('data unavailable') ||
    token.includes('data-unavailable') ||
    token.includes('unavailable') ||
    token.includes('read_unavailable') ||
    token.includes('readunavailable') ||
    token.includes('read unavailable') ||
    token.includes('read-unavailable') ||
    token.includes('read_blocked') ||
    token.includes('readblocked') ||
    token.includes('read blocked') ||
    token.includes('read-blocked') ||
    token.includes('read_failure') ||
    token.includes('readfailure') ||
    token.includes('read failure') ||
    token.includes('read-failure') ||
    token.includes('read_failed') ||
    token.includes('readfailed') ||
    token.includes('read failed') ||
    token.includes('read-failed') ||
    token.includes('write_blocked') ||
    token.includes('writeblocked') ||
    token.includes('write blocked') ||
    token.includes('write-blocked') ||
    token.includes('backend_blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend blocked') ||
    token.includes('backend-blocked') ||
    token.includes('backend_failure') ||
    token.includes('backendfailure') ||
    token.includes('backend failure') ||
    token.includes('backend-failure') ||
    token.includes('technical_marker') ||
    token.includes('technicalmarker') ||
    token.includes('technical marker') ||
    token.includes('technical-marker') ||
    token.includes('payment_backend_blocked') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment backend blocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('reward_backend_blocked') ||
    token.includes('rewardbackendblocked') ||
    token.includes('reward backend blocked') ||
    token.includes('reward-backend-blocked') ||
    token === 'stub' ||
    token === 'blocked' ||
    token === 'failed' ||
    token === 'failure' ||
    token === 'error'
}

function isActiveReadMarker(value) {
  const token = fallbackToken(value)
  return value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(token) || isReadUnavailableToken(value)
}

function isReadMarkerKey(key) {
  const token = fallbackToken(key)
  return token.includes('fallback') ||
    token.includes('readonly') ||
    token.includes('read_only') ||
    token.includes('read-only') ||
    token.includes('mock') ||
    token.includes('stub') ||
    token.includes('unimplemented') ||
    token.includes('notimplemented') ||
    token.includes('not_implemented') ||
    token.includes('not_supported') ||
    token.includes('notsupported') ||
    token.includes('notconnected') ||
    token.includes('not_connected') ||
    token.includes('unsupported') ||
    token.includes('dataunavailable') ||
    token.includes('data_unavailable') ||
    token.includes('unavailable') ||
    token.includes('readunavailable') ||
    token.includes('read_unavailable') ||
    token.includes('readblocked') ||
    token.includes('read_blocked') ||
    token.includes('readfailure') ||
    token.includes('read_failure') ||
    token.includes('readfailed') ||
    token.includes('read_failed') ||
    token.includes('writeblocked') ||
    token.includes('write_blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend_blocked') ||
    token.includes('backend-blocked') ||
    token.includes('backendfailure') ||
    token.includes('backend_failure') ||
    token.includes('technicalmarker') ||
    token.includes('technical_marker') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment_backend_blocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('rewardbackendblocked') ||
    token.includes('reward_backend_blocked') ||
    token === 'blocked' ||
    token === 'failed' ||
    token === 'failure'
}

function hasReadFallbackMarker(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => hasReadFallbackMarker(item, depth + 1, seen))
  return Object.keys(payload).some(key => {
    const value = payload[key]
    const keyToken = fallbackToken(key)
    if (isReadMarkerKey(keyToken) && isActiveReadMarker(value)) return true
    if (value && typeof value === 'object') return hasReadFallbackMarker(value, depth + 1, seen)
    return isReadUnavailableToken(value)
  })
}

function isReadOk(res) {
  return isOk(res) && !hasReadFallbackMarker(res)
}

function firstRecordObject(source) {
  if (Array.isArray(source)) return source.find(item => item && typeof item === 'object') || {}
  if (!source || typeof source !== 'object') return {}
  for (const key of ['records', 'list', 'dataList']) {
    const records = source[key]
    if (Array.isArray(records)) {
      const record = records.find(item => item && typeof item === 'object')
      if (record) return record
    }
  }
  return {}
}

function firstCreditValue(source) {
  if (!source || typeof source !== 'object') return undefined
  for (const body of [source, firstRecordObject(source)]) {
    for (const key of ['creditPoints', 'credit_points', 'creditScore', 'credit_score', 'score', 'points']) {
      const value = body[key]
      if (value !== undefined && value !== null && value !== '') return value
    }
  }
  return undefined
}

export default {
  name: 'Cp',
  components: {},
  data() {
    return {
      creditPoints: 0,
      readError: ''
    }
  },
  mounted() {
    this.Init()
  },
  methods: {
    goToBack() {
      this.$router.go(-1)
    },
    async Init() {
      try {
        const data = await Init()
        if (handleNeedLogin(this, data, this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now', { isValue: 'isLogin' }, { replace: true })) {
          this.readError = failMessage(data, 'This feature is temporarily unavailable. Please try again later.')
          return
        }
        if (isReadOk(data)) {
          this.readError = ''
          this.creditPoints = toNumber(firstCreditValue(contentOf(data)))
        } else {
          const message = failMessage(data, 'This feature is temporarily unavailable. Please try again later.')
          this.readError = message
          safeToast(this, {
            message,
            icon: 'cross'
          })
        }
      } catch (e) {
        const message = cpFailureMessage(e, '当前信誉积分读取失败，已保留已加载数据。')
        this.readError = message
        safeToast(this, {
          message,
          icon: 'cross'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.cp-bg {
  // background: url(../../../assets/img/home/cp-bg.png) no-repeat;
  background-size: 100% 100%;
  height: 338px;
}
.dp-bg {
  background: url(../../../assets/img/home/dp-bg.png) no-repeat;
  background-size: 100% 100%;
  height: 250px;
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px auto 0;
  display: flex;
  flex-flow: column;
  p {
    font-size: 48px;
    font-weight: bold;
    // text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
    //   1px 1px 0 black, 0 0 2px black; /* 可选：增加边缘模糊效果 */
    color: #23baae;
  }
}
.cp-read-error {
  margin: 0 16px 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(220, 38, 38, 0.12);
  border: 1px solid rgba(220, 38, 38, 0.28);
  color: #b91c1c;
  font-size: var(--vk-fs-xs);
  line-height: 18px;
}
.cp-bootom {
  background-image: linear-gradient(180deg, #ffffff 0%, #e9f9f9 100%);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 18px;
  margin: 0 auto;
  border-radius: 15px;
  line-height: 15px;
  width: 93%;
}
.cp-bootom--b {
  padding: 25px 0 0 0;
  // background: url(../../../assets/img/home/bottom-cretire.png) no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  width: 100%;
}
</style>
